module.exports = __webpack_public_path__ + "img/MOTE-Gricd_Smart_Monitoring.4a111405.png";